import 'css-chunk:src/feature/notification/AuthRequestToastNotification.module.scss';export default {
  "root": "AuthRequestToastNotification_root"
};